module.exports = __webpack_public_path__ + "img/logo.d0138b9f.png";